export default function QuickLinkCard({
  name,
  description,
  icon,
  handleClick,
}) {
  const Icon = icon
  return (
    <div
      onClick={handleClick}
      className="rounded-sm border group cursor-pointer overflow-clip hover:bg-gray-50 transition-all duration-300 ease-in-out border-gray-300 bg-white items-center flex shadow-none justify-start"
    >

      <span className="h-full w-5 border-r border-gray-200 bg-[#F1EFE8]" />

      <span className="flex flex-col gap-1 items-start h-full justify-start p-3 relative">
        <p className="text-sm font-medium font-taurus">{name}</p>
        <Icon size={18} className="text-default-300 absolute top-2 right-2" />
        <p className="text-xs text-default-500">{description}</p>
      </span>

    </div>
  )
}
